import styled from 'styled-components'
import { VerticalCol } from '../../utils/Grid'
import { SIZES } from '../../../constants'

export default styled(VerticalCol)`
  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }
  
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    overflow: hidden;
  }
`
